"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lastebasse": {
    "32292c06": [{
      "hkey": "14b077a3",
      "slug": "villaggio-fiorentini",
      "name": "Villaggio Fiorentini",
      "primary": true,
      "skipSearch": false
    }],
    "fiorentini": [{
      "hkey": "14b077a3",
      "slug": "villaggio-fiorentini",
      "name": "Villaggio Fiorentini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lastebasse"
    }],
    "3c31ccdf": [{
      "hkey": "1b31a26b",
      "slug": "lastebasse",
      "name": "Lastebasse",
      "primary": true,
      "skipSearch": false
    }],
    "giaconi": [{
      "hkey": "1b31a26b",
      "slug": "lastebasse",
      "name": "Lastebasse",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a990b781": [{
      "hkey": "14b077a3",
      "slug": "villaggio-fiorentini",
      "name": "Villaggio Fiorentini",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio": [{
      "hkey": "14b077a3",
      "slug": "villaggio-fiorentini",
      "name": "Villaggio Fiorentini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;